// @flow

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider as P, ErrorBoundary } from '@rollbar/react'
import { Detector } from 'react-detect-offline'

import { store, persistor } from './store/index'
import { useInternetConnectionHandler } from './hooks'
import { ANALYTICS_HELPER, APP_HELPER } from './utils'
import App from './App.react'

import './assets/sass/app.scss'
import './assets/Table.css'
import './App.css'

// same configuration you would create for the Rollbar.js SDK
const rollbarConfig = {
	accessToken: process.env.REACT_APP_ROLLBAR_TOKEN,
	captureUncaught: true,
	captureUnhandledRejections: true,
	payload: {
		environment: process.env.REACT_APP_ENVIRONMENT,
	},
} 

const rootElement = document.getElementById('root')
/*
  INITIALIZE ANALYTICS
*/
ANALYTICS_HELPER._initializeGA()
ANALYTICS_HELPER._initializebShop()
APP_HELPER.LOAD_APPLICATION()
if (rootElement) {
	ReactDOM.render(
		<P config={rollbarConfig}>
			<Provider store={store}>
				<ErrorBoundary>
					<PersistGate loading={null} persistor={persistor}>
						<Detector
							render={({ online }) => {
								useInternetConnectionHandler(online)
								return <App />
							}}
						/>
					</PersistGate>
				</ErrorBoundary>
			</Provider>
		</P>,
		rootElement
	)
} else {
	throw new Error('Could not find root element to mount to!')
}
